import {Injectable} from '@angular/core';
import {ApiService} from '../../../../services/api.service';
import {SweetalertService} from '../../../../services/sweetalert.service';
import {Subject} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';

@Injectable()
export class ProposalListService {
  public status;
  public pool;
  public isLoading;
  private observer: any = new Subject();
  public proposals = this.observer.asObservable();

  constructor(
    private apiService: ApiService,
    private sweetalertService: SweetalertService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {
    this.activatedRoute.queryParams.subscribe(params => {
      if (this.router.url.startsWith('/admin/proposal')) {
        this.status = params.status;
        this.pool = params.pool;
        this.refreshProposalList(params.status, params.proposal_pool);
      }
    });
  }

  public refreshProposalList(proposalStatus = this.status, proposalPool = this.pool) {
    this.isLoading = true;
    this.apiService.getProposals({proposalStatus, proposalPool}).subscribe((response: any) => {
      this.isLoading = false;
      this.observer.next(response.data);
    }, error => {
      this.sweetalertService.connectionError();
    });
  }
}
